import React from "react";
import FAQsContent from "../FunctionComponents/FAQsFolder/FAQsContent";

function FAQs() {
  return (
    <>
      <FAQsContent />
    </>
  );
}

export default FAQs;
